"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign = void 0;
var ripple_binary_codec_1 = require("ripple-binary-codec");
var ripple_keypairs_1 = require("ripple-keypairs");
var xrpl_sign_keypairs_1 = __importDefault(require("xrpl-sign-keypairs"));
var Account_1 = __importDefault(require("../schema/Account"));
var sign = function (transaction, account) {
    var _a, _b, _c;
    var accounts = [];
    var Tx = Object.assign({}, transaction);
    if (Object.keys(Tx).indexOf("TransactionType") > -1) {
        if (((_a = Tx === null || Tx === void 0 ? void 0 : Tx.TransactionType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "signin") {
            Object.assign(Tx, {
                TransactionType: undefined,
                SignIn: true,
            });
        }
    }
    if (account instanceof Object && !Array.isArray(account)) {
        if (account instanceof Account_1.default) {
            accounts.push(account);
        }
        else {
            throw new Error("Account not instanceof XRPL Account");
        }
    }
    else if (Array.isArray(account)) {
        account.forEach(function (account) {
            if (account instanceof Account_1.default) {
                accounts.push(account);
            }
            else {
                throw new Error("Account not instanceof XRPL Account");
            }
        });
    }
    if (((_b = Tx === null || Tx === void 0 ? void 0 : Tx.TransactionType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "paymentchannelauthorize" ||
        ((_c = Tx === null || Tx === void 0 ? void 0 : Tx.command) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === "channel_authorize" ||
        (!(Tx === null || Tx === void 0 ? void 0 : Tx.TransactionType) && !(Tx === null || Tx === void 0 ? void 0 : Tx.command) && (Tx === null || Tx === void 0 ? void 0 : Tx.channel) && (Tx === null || Tx === void 0 ? void 0 : Tx.amount))) {
        if (accounts.length === 1) {
            if (typeof accounts[0]._signAs === "string" &&
                accounts[0]._signAs !== "") {
                throw new Error("Payment channel authorization: cannot Sign As");
            }
            var claimInput = { channel: Tx.channel, amount: Tx.amount };
            var claim = ripple_binary_codec_1.encodeForSigningClaim(claimInput);
            var signed = ripple_keypairs_1.sign(claim, accounts[0].keypair.privateKey);
            return {
                type: "SignedPayChanAuth",
                id: "",
                signedTransaction: signed,
                txJson: claimInput,
                signers: [accounts[0].address || ""],
            };
        }
        else {
            throw new Error("Payment channel authorization: multi-signing not supported");
        }
    }
    if (accounts.length === 1) {
        var txJSON = JSON.stringify(Tx);
        var signAs = {};
        if (typeof accounts[0]._signAs === "string" && accounts[0]._signAs !== "") {
            // signAs explicitly set
            signAs = { signAs: accounts[0]._signAs };
        }
        var tx = xrpl_sign_keypairs_1.default(txJSON, accounts[0].keypair, signAs);
        return {
            type: "SignedTx",
            id: tx.id,
            signedTransaction: tx.signedTransaction,
            txJson: tx.txJson,
            signers: [
                typeof accounts[0]._signAs === "string"
                    ? accounts[0]._signAs
                    : accounts[0].address || "",
            ],
        };
    }
    else {
        var RippleLibApi = require("ripple-lib").RippleAPI;
        var RippleApi_1 = new RippleLibApi();
        var Codec = require("ripple-binary-codec");
        var MultiSignedTransactionBinary = (function () {
            if (transaction instanceof Object &&
                Array.isArray(transaction) &&
                accounts.length === 0 &&
                transaction.length > 0) {
                if (transaction.length ===
                    transaction.filter(function (t) {
                        return (t instanceof Object &&
                            t !== null &&
                            typeof t.signedTransaction === "string");
                    }).length) {
                    // MultiSign [ { signedTransaction: ... } , ... ]
                    return RippleApi_1.combine(transaction.map(function (t) {
                        return t.signedTransaction.toUpperCase();
                    }));
                }
                else if (transaction.length ===
                    transaction.filter(function (t) {
                        return (typeof t === "string" && t.toUpperCase().match(/^[A-F0-9]+$/));
                    }).length) {
                    // MultiSign [ 'AEF9...', 'C6DA...' ]
                    return RippleApi_1.combine(transaction.map(function (t) {
                        return t.toUpperCase();
                    }));
                }
                else {
                    throw new Error("TX Blob for multiSign not an array of { signedTransaction: ... } objects or blob strings");
                }
            }
            else {
                // MultiSign [ lib.sign(...), lib.sign(...) ]
                return RippleApi_1.combine(accounts.map(function (account) {
                    return xrpl_sign_keypairs_1.default(JSON.stringify(Tx), account.keypair, {
                        signAs: typeof account._signAs === "string"
                            ? account._signAs
                            : account.address,
                    }).signedTransaction;
                }));
            }
        })();
        var txJson = Codec.decode(MultiSignedTransactionBinary.signedTransaction);
        return {
            type: "MultiSignedTx",
            id: MultiSignedTransactionBinary.id,
            signedTransaction: MultiSignedTransactionBinary.signedTransaction,
            txJson: txJson,
            signers: txJson.Signers,
        };
    }
};
exports.sign = sign;
exports.default = sign;
